var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{staticClass:"site-form",class:[
  _vm.labelPosition ? 'site-form--label-' + _vm.labelPosition : '',
  { 'site-form--inline': _vm.inline }
]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }